module.exports = __webpack_public_path__ + "img/icon-01.2f8d9b1c.png";